import { PaymentType } from './payment.models';

/**
 * Returns the label for a given payment type.
 * @param paymentType The payment type.
 * @returns The label for the payment type.
 */
export function getPaymentTypeLabel(paymentType: PaymentType): string {
  switch (paymentType) {
    case PaymentType.CREDITCARD:
      return 'Tarjeta de Crédito';
    case PaymentType.TRANSFER:
      return 'Transferencia bancaria directa';
    case PaymentType.FULLBONUS:
      return 'Totalidad del Pago con Bono o Cupón';
    case PaymentType.BIZUM:
      return 'Bizum';
    default:
      return '';
  }
}
